import * as Yup from "yup"
// Yup validation schema
export const AddAlertValidationSchema = Yup.object().shape({
    alertName: Yup.string().required("Alert Name is required"),
    selectedUsers: Yup.array().min(1, "At least one user must be selected"),
    selectedTime: Yup.object().required("Time is required").nullable(),
    selectedTimezone: Yup.object().required("Timezone is required").nullable(),
    selectedAsset: Yup.string().test(
        "asset-required",
        "Asset is required",
        (val) => val && val !== "select-value",
    ),
    assetProperty: Yup.array()
        .of(
            Yup.object().shape({
                name: Yup.string().required("Name is required"),
                details: Yup.object().shape({
                    type: Yup.string().nullable(),
                    validation: Yup.object().shape({
                        min_value: Yup.string()
                            .nullable()
                            .when("../type", {
                                is: "range",
                                then: Yup.string().required("Min value is required"),
                                otherwise: Yup.string().nullable(),
                            }),
                        max_value: Yup.string()
                            .nullable()
                            .when("../type", {
                                is: "range",
                                then: Yup.string().required("Max value is required"),
                                otherwise: Yup.string().nullable(),
                            }),
                        possible_value: Yup.array()
                            .nullable()
                            .when("../type", {
                                is: "dropdown",
                                then: Yup.array().of(
                                    Yup.string().required("Dropdown option is required"),
                                ),
                                otherwise: Yup.array().nullable(),
                            }),
                    }),
                }),
            }),
        )
        .test(
            "at-least-one-asset-property",
            "At least one Asset Property value is required",
            (arr) => !arr || arr.some((item) => item.assetValue && item.assetValue !== ""),
        ),
    // Custom test for at least one of zones or filters
    // zoneOrFilter: Yup.mixed().test(
    //     "zone",
    //     "At least one Zone selection is required",
    //     function (_, context) {
    //         const { selectedValues } = this.parent
    //         const hasZone =
    //             selectedValues && Object.values(selectedValues).some((arr) => arr && arr.length > 0)
    //         return hasZone
    //     },
    // ),
})
